<template>
  <md-dialog
    :md-active.sync="isDialogVisible"
    :md-click-outside-to-close="true"
    @md-opened="dialogOpened"
  >
    <md-dialog-title>Please provide workflow name</md-dialog-title>
    <form id="this.form_id" @submit.prevent="save">
      <md-dialog-content>
        <!-- <md-tabs>
          <md-tab md-label="Load Saved Workflow"> -->
            <md-autocomplete
              ref="workflowName"
              :class="getValidationClass('workflowName')"
              v-model="model.workflowName"
              :md-options="workflows"
              @md-changed="getWorkflows"
              @md-opened="getWorkflows"
            >
              <label>Workflow name</label>
              <template slot="md-autocomplete-item" slot-scope="{ item }" > {{ item }} </template>
              <span class="md-error" v-if="!$v.model.workflowName.required">Workflow name is required</span>
            </md-autocomplete>      
          <!-- </md-tab>
          <md-tab md-label="Paste Shared Workflow">
            <md-field>
                <md-textarea v-model="pastedWorkflow">
                </md-textarea>
            </md-field>
          </md-tab>  
        </md-tabs> -->
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeDialog">Close</md-button>
        <md-button type="submit" class="md-primary">Load</md-button>
      </md-dialog-actions>
    </form>
  </md-dialog>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { AuthService } from "@/services/auth.service";
import { organisationsCollection } from "@/firebase.js";

export default {
  name: "WorkflowLoad",
  mixins: [validationMixin],
  data: () => ({
    model: {},
    isDialogVisible: false,
    workflows: [],
    pastedWorkflow: ""
  }),
  validations() {
    if(this.pastedWorkflow.length > 0){
      return{
        model: {
          workflowName: {

          }
        }
      }
    } else {
      return {
        model: {
          workflowName: {
            required
          }
        }
      }
    }
  },
  methods: {
    showDialog() {
      this.isDialogVisible = true;
      this.getWorkflows();
      this.model = {};
    },
    closeDialog(){
      this.isDialogVisible = false;
      this.pastedWorkflow = "";
    },
    dialogOpened() {
      this.$v.$reset();
    },
    getValidationClass(fieldName) {
      const field = this.$v.model[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    getWorkflows(searchTerm) {
      this.workflows = new Promise(resolve => {
        let orgDoc = organisationsCollection.doc(this.user.orgId);
        orgDoc.collection("workflows").get().then(querySnapshot => {
          let workflows = [];
          querySnapshot.forEach(doc => {
            workflows.push(doc.id);
            console.log(doc.id);
          });
          
          if (searchTerm) {
            const term = searchTerm.toLowerCase();
            
            workflows = workflows.filter(workflow => workflow.toLowerCase().includes(term));
          }
            console.log('workflows, ', workflows);
          resolve(workflows);
        });        
      });
    },
    save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      if(this.pastedWorkflow.length > 0) {
        console.log('pasted workflow', this.pastedWorkflow)
        this.$emit("paste", this.pastedWorkflow);
      } else {
        this.$emit("load", this.model.workflowName);
      }
      
      this.pastedWorkflow = "";
      this.isDialogVisible = false;
    }
  },
  created() {    
    this.subscription = AuthService.loggedUser$.subscribe(user => this.user = user);    
  },
  beforeDestroy() {
    this.subscription.unsubscribe();
  },
};
</script>

<style scoped lang="scss">
.md-dialog-title {
  margin-bottom: 0;
}
</style>
